import { Log } from '@shared/debug/log';
import { MarkingCardInfo } from '../../layout/marking-cards-selection/marking-cards-selection.component';
import { WizardModel } from '../wizard-model';
import { ConfigurationTemplate } from '../wizard-model.interface';
import { lastValueFrom } from 'rxjs';
import { ArticleVO } from '@article/model/vo/article.vo';
import { ArticleDataService } from '@article/service/article-data.service';
import { ConfigurationCreationService } from '../../service/configuration-creation.service';
import { MarkingSystemProjectCreationService } from '../../service/marking-system-project-creation.service';
import { Injectable } from '@angular/core';

@Injectable()
export class MarkingCardsModel extends WizardModel {
  public readonly type = "MARKING_CARDS";

  private _selectedOptions: {[option: string]: MarkingCardInfo} = {};

  constructor(
    private markingSystemProjectCreationService: MarkingSystemProjectCreationService,
    private articleDataService: ArticleDataService,
    private configurationCreationService: ConfigurationCreationService,
  ) {
    super();
  }

  public selectValue(step: number, value: any): void {
    const currentStepConfig = this.config.steps[step];
    if (step < 0 || !currentStepConfig) {
      return;
    }
    const currentStepTitle = currentStepConfig.id;
    this._selectedOptions[currentStepTitle] = value;
  }

  public async create(): Promise<void> {
    if (this.creationStarted) {
      return;
    }
    this.creationStarted = true;
    await this.createNewProject();
    this.creationStarted = false;
  }

  private async createNewProject(): Promise<void> {
    const articleInfo: MarkingCardInfo = this._selectedOptions['article'];
    await this.configurationCreationService.prepareNewConfiguration(this.metaData);
    try {
      const articleVo = await this.loadArticleVO(articleInfo);
      await this.markingSystemProjectCreationService.createNewProject(articleVo, articleInfo.color);
    } catch (error: any) {
      Log.error('error creating new project: ', error);
    }
  }

  private async loadArticleVO(articleInfo: MarkingCardInfo): Promise<ArticleVO> {
    return await lastValueFrom(this.articleDataService.loadArticleByArticleId(articleInfo.articleId));
  }

  protected createConfig(): ConfigurationTemplate {
    return {
      id: "create-project-marking",
      type: 'type',
      imageUrl: "ng-assets/img/projecttypes/marking-cards.webp",
      label: "configurationCreation.type.marking_cards",
      steps: [
        {
          type: "meta",
          id: "meta",
          label: "configurationCreation.progress.configuration_data",
        },
        {
          type: "markingCardsSelection",
          id: "article",
          label: "configurationCreation.progress.marking_cards_selection.label",
        }
      ]
    }
  }
}
